import React, { useState } from "react";
import { Button, Col, Form, message, Modal, Row, Skeleton } from "antd";

import { useFetchConstant } from "apis/constant";

import FormInput from "components/FormInput/FormInput";
import FormAutoComplete from "components/FormAutoComplete/FormAutoComplete";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { confirm } = Modal;

const AddFundDistributionModal = ({
  defaultValues,
  onOk,
  onClose,
  onRemove,
  visible,
}) => {
  const [form] = useForm();
  const {
    isLoading: isInvestmentPlansLoading,
    selection: investmentPlans,
  } = useFetchConstant("investmentPlans", "label");
  const [selections, setSelections] = useState([]);

  const isConstantsLoading = isInvestmentPlansLoading;

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      message.error(error);
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: Locale.get("ownedPolicies.fundDistributionTab.confirmTitle"),
      okText: Locale.get("ownedPolicies.fundDistributionTab.yesButton"),
      onOk() {
        onRemove();
      },
      onClose() {},
    });
  };

  const handleOnSearchEvents = (inputValue) => {
    const newSelections = inputValue
      ? investmentPlans.filter((plan) => {
          const upperCaseSuggestionValue = plan.value.toUpperCase();
          return upperCaseSuggestionValue.includes(inputValue.toUpperCase());
        })
      : [];

    setSelections(newSelections);
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          {Locale.get("ownedPolicies.fundDistributionTab.removeButton")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("ownedPolicies.fundDistributionTab.saveFundButton")}
        </Button>,
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          {Locale.get("ownedPolicies.fundDistributionTab.cancelButton")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("ownedPolicies.fundDistributionTab.addNewFundButton")}
        </Button>,
      ];

  return (
    <Modal
      title={Locale.get(
        "ownedPolicies.fundDistributionTab.fundDistributionDetail"
      )}
      visible={visible}
      onOk={handleOnOkButtonClick}
      onCancel={onClose}
      footer={footer}
      width="60%"
    >
      <Form form={form} initialValues={defaultValues}>
        {isConstantsLoading ? (
          <Skeleton active />
        ) : (
          <Row gutter={16}>
            <Col span={12}>
              <FormAutoComplete
                label={Locale.get(
                  "ownedPolicies.fundDistributionTab.fundTitle"
                )}
                name="type"
                requiredErrorMessage={Locale.get(
                  "ownedPolicies.fundDistributionTab.errMsgFundTitle"
                )}
                selections={selections}
                onSearch={handleOnSearchEvents}
              />
            </Col>
            <Col span={12}>
              <FormInput
                label={Locale.get("ownedPolicies.fundDistributionTab.amount")}
                name="amount"
                placeholder="0.00"
                type="financial"
              />
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
};

export default AddFundDistributionModal;
